import React from 'react'
import PropTypes from 'prop-types'
import { useAbundancePanel } from './AbundanceViewPanel'

function AbundanceViewPanelTrigger ({ bindings, enabled, className, style, children }) {
  const panel = useAbundancePanel()

  return (
    <div
      role={enabled ? 'button' : ''}
      tabIndex={enabled ? 0 : -1}
      onClick={() => enabled ? panel.open(bindings) : null}
      onKeyDown={(event) => {
        if (enabled && (event.keyCode === 13 || event.keyCode === 32)) {
          panel.open(bindings)
        }
      }}
      className={className}
      style={style}
    >
      {children}
    </div>
  )
}

AbundanceViewPanelTrigger.propTypes = {
  bindings: PropTypes.any,
  enabled: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.any
}

AbundanceViewPanelTrigger.defaultProps = {
  enabled: true
}

export default AbundanceViewPanelTrigger
